import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import SpeechBubble from './SpeechBubble';
import {
  getTranscriptionLineTags,
  NO_TRANSCRIPTION_MESSAGE,
} from './transcription.utils';

interface BubbleChatProps {
  transcriptLines: string[];
}

const BubbleChat = ({ transcriptLines }: BubbleChatProps) => {
  // Extract unique speakers from transcript lines
  const speakers = useMemo(() => {
    const uniqueSpeakers: string[] = [];
    transcriptLines.forEach(line => {
      const { name } = getTranscriptionLineTags(line);
      if (!uniqueSpeakers.includes(name)) {
        uniqueSpeakers.push(name);
      }
    });
    return uniqueSpeakers;
  }, [transcriptLines]);

  if (transcriptLines.length === 0) {
    return (
      <Typography variant="bodyLarge" component="p">
        No transcript available. Please wait for the transcript to be generated.
      </Typography>
    );
  }

  if (transcriptLines[0] === NO_TRANSCRIPTION_MESSAGE) {
    return (
      <Typography variant="bodyLarge" component="p">
        {NO_TRANSCRIPTION_MESSAGE}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {transcriptLines.map(line => {
        const { name, time, text } = getTranscriptionLineTags(line);

        const key = `${name}-${time}`;

        return (
          <SpeechBubble
            key={key}
            name={name}
            time={time}
            text={text}
            anchor={speakers.indexOf(name) % 2 === 0 ? 'left' : 'right'}
          />
        );
      })}
    </Box>
  );
};

export default BubbleChat;
